export default __webpack_public_path__ + "static/media/1.2d5a0f9f.jpg";